import { Component, Input, OnInit } from '@angular/core';
import { ModalService } from '@usitsdasdesign/dds-ng/modal';
import { SubmissionService } from '../../../../../../http/intake/submission.service';
import { ProgressIndicatorService } from '../../../../../../common/services/progress-indicator.service';
import { SelectItemOptions } from '@usitsdasdesign/dds-ng/select';
import { Subject, takeUntil } from 'rxjs';
import { IntakeConstant } from '../../../../../constants/intake.constant';
import { CommonHelperService } from '../../../../../../common/services/common-helper.service';
import {
  INTERNAL_RM_REVIEWED_DOC_STATUS_ALLOWED_ROLES,
  updateDocStatusDropdown,
} from '../../document-settings';
import {
  IntakeDocumentStatusIdMapper,
  DocumentStatus,
} from '../../../../../constants/document-status.enum';
import { AdminModuleService } from '../../../../../../admin/admin-services/admin-module.service';
import { ButtonComponent } from '@usitsdasdesign/dds-ng/button';
import { NotifyPopupComponent } from '../../../../../../common/notify-popup/notify-popup.component';
import {
  IntakeDocumentType,
  IntakeDocumentTypeToIdMapper,
} from '../../../../../constants/intake-document-type.enum';

@Component({
  selector: 'app-document-link-upload',
  templateUrl: './document-link-upload.component.html',
  styleUrl: './document-link-upload.component.less',
})
export class DocumentLinkUploadComponent implements OnInit {
  constructor(
    private readonly modalService: ModalService,
    private readonly intakeDetailService: SubmissionService,
    private commonHelperService: CommonHelperService,
    private readonly adminModuleService: AdminModuleService
  ) {}
  @Input() public documentInitiatedDetails: any = {};
  @Input() rmReviewedGuidanceNoteHeader: string = IntakeConstant.EMPTY_SPACE;
  @Input() rmReviewedGuidanceNoteBody: string = IntakeConstant.EMPTY_SPACE;
  @Input() documentTypeOptions: SelectItemOptions[] = [];
  @Input() set setDocumentStatusOptions(value: SelectItemOptions[]) {
    this.documentStatusOptions = value;
    this.allStatusAvailable = value;
  }

  documentLink: string = '';
  documentTitle: string = '';
  selectedDocType: number = 0;
  selectedDocStatus: number = 0;
  documentLinkConfigData: any = {};
  documentComment: string = '';
  readonly #unsubscriber$: Subject<void> = new Subject<void>();
  documentStatusOptions: SelectItemOptions[] = [];
  allStatusAvailable: SelectItemOptions[] = [];
  otherStatus: number = IntakeDocumentTypeToIdMapper[IntakeDocumentType.Other];
  InternalRmReviewedDocStatusAllowedRoles: string[] =
    INTERNAL_RM_REVIEWED_DOC_STATUS_ALLOWED_ROLES;
  showRMReviewedGuidanceNote: boolean = false;

  ngOnInit(): void {
    this.getDocumentLinkLabelData();
  }

  getDocumentLinkLabelData() {
    this.adminModuleService
      .getConfigurationDocumentLinkLabelData()
      .pipe(takeUntil(this.#unsubscriber$))
      .subscribe((data) => {
        if (data != null) this.documentLinkConfigData = data;
      });
  }

  onDocTypeChange(): void {
    this.updateStatusDropdown();
  }

  onDocStatusChange(): void {
    const rmReviewdId = IntakeDocumentStatusIdMapper.get(
      DocumentStatus.RMReviewed
    );
    this.selectedDocStatus === rmReviewdId
      ? (this.showRMReviewedGuidanceNote = true)
      : (this.showRMReviewedGuidanceNote = false);
  }

  updateStatusDropdown(): void {
    const { statusOptions, selectedDocStatus } = updateDocStatusDropdown(
      this.allStatusAvailable,
      this.documentInitiatedDetails.submissionTypeCode,
      this.documentInitiatedDetails.submissionStatus,
      this.selectedDocType,
      this.selectedDocStatus
    );

    this.documentStatusOptions = statusOptions;
    if (selectedDocStatus !== null) {
      this.selectedDocStatus = selectedDocStatus;
    }
  }

  IsDocumentLinkValid(): boolean {
    let isDocLinkValid = false;
    const docLink = this.documentLink.split('/');
    const collaborationSites =
      this.documentLinkConfigData?.documentLabelSites?.split(',');
    if (docLink.length > 0 && collaborationSites.length > 0) {
      let collaborationPart = docLink[2]?.toString();
      collaborationSites.forEach((site: any) => {
        if (collaborationPart?.toLowerCase().includes(site?.toLowerCase())) {
          isDocLinkValid = true;
        }
      });
    }
    return isDocLinkValid;
  }

  removeBodyOverflow() {
    document.body.style.overflow = 'hidden';
  }
  applyBodyOverflow() {
    document.body.style.overflowY = 'auto';
  }
  showMsg(modalBtn?: ButtonComponent, title: string = 'Warning') {
    this.removeBodyOverflow();
    let modalRef = this.modalService.open(NotifyPopupComponent, {
      isFooter: true,
      size: 'md',
      isInverse: false,
      notifyReason: this.documentLinkConfigData?.documentLabelErrorMsg,
      footerButtonText: 'Dismiss',
      title,
    });
    modalRef.onClosed().subscribe(() => {
      this.applyBodyOverflow();
      if (modalBtn) {
        modalBtn.focus();
      }
    });
  }

  async saveDocumentLink(): Promise<void> {
    const postRequestData = [
      {
        submissionId: this.documentInitiatedDetails.submissionId,
        documentTypeId: this.selectedDocType,
        documentStatusId: this.selectedDocStatus,
        submissionDocumentTypeId: 2,
        documentTitle: this.commonHelperService.trimPrefixEmptySpace(
          this.documentTitle
        ),
        documentUrl: this.documentLink,
        comments: this.commonHelperService.trimPrefixEmptySpace(
          this.documentComment
        ),
        attachmentId: null,
      },
    ];
    return new Promise((resolve, reject) => {
      this.intakeDetailService
        .postDocumentSave(postRequestData)
        .pipe(takeUntil(this.#unsubscriber$))
        .subscribe({
          next: (response: any) => {
            resolve();
          },
          error: (err) => {
            reject(err);
          },
        });
    });
  }

  formValid(): boolean {
    if (
      this.documentLink.length > 0 &&
      this.documentTitle.length > 0 &&
      this.selectedDocType != 0 &&
      this.selectedDocStatus != 0
    ) {
      if (
        this.selectedDocType === this.otherStatus &&
        this.documentComment.length > 0
      ) {
        return true;
      } else if (
        this.selectedDocType === this.otherStatus &&
        this.documentComment.length === 0
      ) {
        return false;
      }
      return true;
    }
    return false;
  }

  async closeAll(): Promise<void> {
    try {
      if (!this.IsDocumentLinkValid()) {
        this.showMsg();
        return;
      }
      await this.saveDocumentLink();
      this.close();
    } catch (error) {}
    this.close();
  }

  close() {
    this.modalService.close();
  }

  ngOnDestroy(): void {
    this.#unsubscriber$.next();
    this.#unsubscriber$.complete();
  }
}
